import { useLocation } from 'react-router-dom';
import { useCallback, useState } from 'react';
import { getVerifyInstall } from '../../verify-install/operators/getVerifyInstall';
import AsyncVerifyScriptPromptCheck from '../../code-splitting/components/AsyncVerifyScriptPromptCheck';
import { jsx as _jsx } from "react/jsx-runtime";
const useComponent = () => {
  const location = useLocation();
  const verify = getVerifyInstall(location);
  const [promptStatus, setPromptStatus] = useState(true);
  const closePrompt = useCallback(() => setPromptStatus(false), []);
  return {
    closePrompt,
    verify,
    promptStatus
  };
};
const InboxVerifyScriptPrompt = () => {
  const {
    closePrompt,
    promptStatus,
    verify
  } = InboxVerifyScriptPrompt.useComponent();
  if (promptStatus && verify) {
    return /*#__PURE__*/_jsx(AsyncVerifyScriptPromptCheck, {
      verify: verify,
      closePrompt: closePrompt
    });
  }
  return null;
};
InboxVerifyScriptPrompt.displayName = 'InboxVerifyScriptPrompt';
InboxVerifyScriptPrompt.useComponent = useComponent;
export default InboxVerifyScriptPrompt;